import { ErrorOutline } from "@mui/icons-material";
import { Alert, AlertColor, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, Typography } from "@mui/material";

interface Props {
  error: string;
  message: string;
  severity?: AlertColor;
}

interface PropsDialog extends DialogProps, Props {
  onClose: () => void;
}

export const ErrorOnDialog: React.FC<PropsDialog> = ({ error, message, onClose, ...dialogProps }) => {
  return <Dialog {...dialogProps}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">
      <div style={{
        display: "flex",
        flexDirection: "row",
      }}>
        <ErrorOutline color="error" />
        <div style={{ width: "15px" }} />
        <Typography fontWeight={"bold"} fontSize={16}>
          {error}
        </Typography>
      </div>
    </DialogTitle>

    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} autoFocus>Ok</Button>
    </DialogActions>
  </Dialog>;
};

export const ErrorModal: React.FC<Props> = ({ error, message }) => {
  return <div style={{
    display: "flex",
    flexDirection: "row",
  }}>
    <ErrorOutline color="error" />
    <div style={{ width: "15px" }} />
    <Typography fontWeight={"bold"} fontSize={16}>
      {error + ": " + message}
    </Typography>
  </div>;
};

export const ErrorOnSnack: React.FC<Props> = ({ error, message, severity }) => {
  return <Alert
    severity={severity}
    sx={{ width: '100%' }}
  >
    {error + ":" + message}
  </Alert>;
};